// Student/parent home (dashboard) and the fee-defaulter portal lock.
// Globally unique (see docs/state-management.md) — prefixed SP_HOME_.
export const SP_HOME_GET_STATS = 'SP_HOME_GET_STATS'
export const SP_HOME_GET_FEED = 'SP_HOME_GET_FEED'
export const SP_HOME_GET_SUBJECTS = 'SP_HOME_GET_SUBJECTS'
export const SP_HOME_GET_LECTURES = 'SP_HOME_GET_LECTURES'
export const SP_HOME_GET_TODAY_ATTENDANCE = 'SP_HOME_GET_TODAY_ATTENDANCE'
export const SP_HOME_GET_TODAY_SUBJECT_ATTENDANCE = 'SP_HOME_GET_TODAY_SUBJECT_ATTENDANCE'
export const SP_HOME_GET_ACCESS_STATUS = 'SP_HOME_GET_ACCESS_STATUS'
export const SP_HOME_GET_ECARD_PROFILE = 'SP_HOME_GET_ECARD_PROFILE'
export const SP_HOME_GET_ECARD_QR = 'SP_HOME_GET_ECARD_QR'
export const SP_HOME_GET_OWN_PROFILE = 'SP_HOME_GET_OWN_PROFILE'
